// Central bilingual content for the Alhilal First website.
// SITE holds domain-level constants used for SEO/meta and structured data.
export const SITE = {
  url: 'https://al-hilal.ly',
  email: 'info@al-hilal.ly',
  phones: ['+218 91 175 1800', '+218 92 175 1800'],
  phonesHref: ['+218911751800', '+218921751800'],
  addressAr: 'مصراتة – طمينة – الطريق الساحلي – ليبيا',
  addressEn: 'Tawmina, Misrata – Coastal Road – Libya',
  mapQuery: 'Tawmina, Misrata, Libya',
};

export const PRODUCTS = [
  {
    code: 'PE-501-F',
    family: 'PE',
    ar: {
      title: 'كربونات كالسيوم مخصصة لتطبيقات البولي إيثيلين (PE)',
      desc: 'تم تطوير هذا المنتج للاستخدام في صناعة الأكياس البلاستيكية ومجموعة من المنتجات البلاستيكية المرنة والتطبيقات المشابهة، حيث يوفر توازنًا مناسبًا بين الأداء وتكلفة الإنتاج.',
      applications: ['الأكياس البلاستيكية', 'المنتجات البلاستيكية المرنة', 'تطبيقات البولي إيثيلين'],
    },
    en: {
      title: 'Calcium Carbonate for Polyethylene (PE) Applications',
      desc: 'Developed for use in plastic bag manufacturing and various flexible plastic applications, providing a suitable balance between performance and production cost.',
      applications: ['Plastic bags', 'Flexible plastic products', 'Polyethylene applications'],
    },
  },
  {
    code: 'PE-502-F',
    family: 'PE',
    ar: {
      title: 'كربونات كالسيوم مخصصة لتطبيقات الأكياس البلاستيكية ذات السماكات الأعلى',
      desc: 'يستخدم هذا المنتج في تصنيع الأكياس البلاستيكية التي تتطلب سماكة أعلى نسبيًا، مع مواصفات مناسبة للتطبيقات التي تحتاج إلى توازن بين الأداء والتكلفة.',
      applications: ['أكياس بلاستيكية عالية السماكة'],
    },
    en: {
      title: 'Calcium Carbonate for Higher-Thickness Plastic Bags',
      desc: 'Designed for plastic bag applications requiring relatively higher thickness, offering a practical balance between performance and cost.',
      applications: ['Higher-thickness plastic bags'],
    },
  },
  {
    code: 'PE-503-F',
    family: 'PE',
    ar: {
      title: 'كربونات كالسيوم اقتصادية لتطبيقات الأكياس البلاستيكية',
      desc: 'يُستخدم هذا المنتج في صناعة الأكياس البلاستيكية والتطبيقات التي تركز على خفض تكلفة الإنتاج، مع توفير مواصفات مناسبة للاستخدامات الأقل تطلبًا من حيث الأداء.',
      applications: ['أكياس بلاستيكية اقتصادية', 'تطبيقات خفض التكلفة'],
    },
    en: {
      title: 'Economical Calcium Carbonate for Plastic Bag Applications',
      desc: 'Designed for plastic bag manufacturing and cost-sensitive applications, providing a practical solution for applications with less demanding performance requirements.',
      applications: ['Economical plastic bags', 'Cost-sensitive applications'],
    },
  },
  {
    code: 'PP-201-NW',
    family: 'PP',
    ar: {
      title: 'كربونات كالسيوم مخصصة لتطبيقات البولي بروبيلين (PP)',
      desc: 'تستخدم في تصنيع الكراسي والمنتجات البلاستيكية الصلبة التي تتطلب مستوى مناسبًا من البياض والمظهر النهائي.',
      applications: ['الكراسي البلاستيكية', 'المنتجات البلاستيكية الصلبة', 'تطبيقات تتطلب بياضًا نسبيًا'],
    },
    en: {
      title: 'Calcium Carbonate for Polypropylene (PP) Applications',
      desc: 'Suitable for manufacturing plastic chairs and rigid plastic products where an appropriate level of whiteness and appearance is required.',
      applications: ['Plastic chairs', 'Rigid plastic products', 'Applications requiring relative whiteness'],
    },
  },
  {
    code: 'PP-202-N',
    family: 'PP',
    ar: {
      title: 'كربونات كالسيوم مخصصة للمنتجات البلاستيكية الصلبة',
      desc: 'تستخدم في تصنيع مجموعة متنوعة من المنتجات البلاستيكية الصلبة، وتناسب التطبيقات التي لا تتطلب إضافة كربونات بهدف تعزيز البياض أو تغيير المظهر النهائي للمنتج.',
      applications: ['منتجات بلاستيكية صلبة متنوعة'],
    },
    en: {
      title: 'Calcium Carbonate for Rigid Plastic Applications',
      desc: 'Suitable for manufacturing a variety of rigid plastic products, particularly applications where additional whitening is not a primary requirement.',
      applications: ['Variety of rigid plastic products'],
    },
  },
  {
    code: 'KPP-600-P',
    family: 'Compound',
    featured: true,
    ar: {
      title: 'خلطة كومباوند جاهزة للاستخدام في صناعة الكراسي والمنتجات البلاستيكية',
      desc: 'منتج مركب وجاهز للاستخدام، مصمم لتسهيل عملية الإنتاج وتقليل الحاجة إلى إضافة مواد خام خارجية، ويحتوي على نسبة مرتفعة من البولي بروبيلين (PP).',
      applications: ['صناعة الكراسي البلاستيكية'],
      features: [
        'جاهز للاستخدام في عملية الإنتاج',
        'يقلل الحاجة إلى إضافة مواد خام خارجية',
        'يحتوي على نسبة مرتفعة من PP',
        'مناسب لتطبيقات صناعة الكراسي البلاستيكية',
      ],
    },
    en: {
      title: 'Ready-to-Use PP Compound for Plastic Chair Manufacturing',
      desc: 'A ready-to-use compound designed to simplify the production process and reduce the need for additional external raw materials. The compound contains a high percentage of Polypropylene (PP) and is suitable for plastic chair manufacturing.',
      applications: ['Plastic chair manufacturing'],
      features: [
        'Ready for production',
        'Reduces the need for additional raw materials',
        'High PP content',
        'Suitable for plastic chair manufacturing',
      ],
    },
  },
  {
    code: 'PP-400-R',
    family: 'PP',
    ar: {
      title: 'كربونات كالسيوم مخصصة لأكياس الرافية وتطبيقات البولي بروبيلين المنسوج',
      desc: 'تستخدم في صناعة أكياس الرافية، بما في ذلك أكياس الأعلاف، وغيرها من المنتجات البلاستيكية المنسوجة ذات السماكات والتطبيقات المماثلة.',
      applications: ['أكياس الرافية', 'أكياس الأعلاف', 'منتجات بولي بروبيلين منسوجة'],
    },
    en: {
      title: 'Calcium Carbonate for Raffia Bags and Woven PP Applications',
      desc: 'Designed for use in the manufacturing of raffia bags, including animal-feed bags, as well as similar woven polypropylene products with comparable thickness and applications.',
      applications: ['Raffia bags', 'Animal-feed bags', 'Woven polypropylene products'],
    },
  },
];

export const CONTENT = {
  ar: {
    dir: 'rtl',
    lang: 'ar',
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      products: 'منتجاتنا',
      facility: 'منشأتنا',
      contact: 'تواصل معنا',
      cta: 'اطلب عرض سعر',
    },
    hero: {
      eyebrow: 'صناعة ليبية موثوقة منذ التأسيس',
      title: 'شركة الهلال الأولى للصناعات البلاستيكية',
      subtitle: 'متخصصون في تصنيع وإنتاج كربونات الكالسيوم بجودة ومواصفات مناسبة لمختلف الصناعات البلاستيكية، لخفض تكاليف الإنتاج وتحسين كفاءته.',
      ctaPrimary: 'تصفّح منتجاتنا',
      ctaSecondary: 'تواصل معنا',
      badges: ['صنع في ليبيا – مصراتة', 'جودة مستقرة', 'شراكات طويلة الأمد'],
    },
    about: {
      title: 'من نحن',
      kicker: 'نبذة عن الشركة',
      paragraphs: [
        'شركة الهلال الأولى للصناعات البلاستيكية هي شركة متخصصة في تصنيع وإنتاج كربونات الكالسيوم (Calcium Carbonate) المستخدمة في مجموعة واسعة من الصناعات والتطبيقات البلاستيكية.',
        'نقدم حلولًا متخصصة تساعد الشركات والمصانع على تحسين كفاءة الإنتاج وخفض تكاليف التصنيع، من خلال توفير كربونات الكالسيوم بجودة ومواصفات مناسبة لمختلف الاستخدامات الصناعية.',
        'نسعى إلى بناء شراكات طويلة الأمد مع عملائنا، من خلال توفير منتجات موثوقة، وجودة مستقرة، وحلول تلبي احتياجات قطاع الصناعات البلاستيكية.',
      ],
    },
    features: {
      title: 'لماذا الهلال الأولى',
      items: [
        {
          title: 'تكلفة أقل',
          desc: 'حلول اقتصادية تساعد المصانع على خفض تكاليف التصنيع دون المساس بالجودة.',
        },
        {
          title: 'جودة أعلى',
          desc: 'مواصفات ثابتة ومضبوطة تضمن أداءً موثوقًا في كل دفعة إنتاج.',
        },
        {
          title: 'مرونة أكثر',
          desc: 'خيارات متعددة من المنتجات تغطي مختلف تطبيقات PE وPP والكومباوند الجاهز.',
        },
      ],
    },
    products: {
      title: 'منتجاتنا',
      kicker: 'كربونات الكالسيوم والخلطات الجاهزة',
      intro: 'تقدم شركة الهلال الأولى للصناعات البلاستيكية مجموعة متنوعة من منتجات كربونات الكالسيوم والخلطات المخصصة لتلبية احتياجات مختلف تطبيقات الصناعات البلاستيكية، مع خيارات متعددة من حيث الأداء، السماكة، البياض، والتكلفة، بما يتناسب مع متطلبات الإنتاج المختلفة.',
      applicationsLabel: 'الاستخدامات',
      featuresLabel: 'المزايا',
      featuredBadge: 'كومباوند جاهز',
    },
    facility: {
      title: 'منشأتنا',
      kicker: 'مصراتة – طمينة',
      desc: 'يقع مقر الشركة على الطريق الساحلي بمنطقة طمينة، مصراتة، حيث تتم عمليات الإنتاج والتعبئة والتخزين وفق معايير تضمن جودة ثابتة لكل دفعة.',
    },
    contact: {
      title: 'تواصل معنا',
      kicker: 'نحن هنا لخدمتكم',
      desc: 'للاستفسارات، طلبات المنتجات، التعاون التجاري، أو الحصول على مزيد من المعلومات حول منتجاتنا، يسعدنا تواصلكم معنا عبر قنوات الاتصال التالية:',
      emailLabel: 'البريد الإلكتروني',
      phoneLabel: 'أرقام الهاتف',
      addressLabel: 'موقع الشركة',
      closing: 'يسعدنا استقبالكم في مقر الشركة والتعرف على احتياجاتكم ومتطلباتكم الصناعية.',
      formTitle: 'أرسل لنا رسالة',
      formName: 'الاسم الكامل',
      formEmail: 'البريد الإلكتروني',
      formMessage: 'رسالتك',
      formSubmit: 'إرسال عبر البريد الإلكتروني',
    },
    footer: {
      tagline: 'كربونات الكالسيوم للصناعات البلاستيكية — صنع في ليبيا',
      rights: 'جميع الحقوق محفوظة',
      quickLinks: 'روابط سريعة',
    },
  },
  en: {
    dir: 'ltr',
    lang: 'en',
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      facility: 'Facility',
      contact: 'Contact',
      cta: 'Request a Quote',
    },
    hero: {
      eyebrow: 'Trusted Libyan Manufacturing',
      title: 'Alhilal First Company',
      subtitle: 'A specialized manufacturer and producer of Calcium Carbonate, used across a wide range of plastic industries and applications — improving production efficiency and reducing manufacturing costs.',
      ctaPrimary: 'Explore Our Products',
      ctaSecondary: 'Contact Us',
      badges: ['Made in Libya – Misrata', 'Consistent Quality', 'Long-Term Partnerships'],
    },
    about: {
      title: 'About Us',
      kicker: 'Company Overview',
      paragraphs: [
        'Al Hilal First Plastic Industries is a specialized manufacturer and producer of Calcium Carbonate, used across a wide range of plastic industries and applications.',
        'We provide specialized solutions that help manufacturers improve production efficiency and reduce manufacturing costs by supplying Calcium Carbonate with consistent quality and specifications tailored to different industrial applications.',
        'We strive to build long-term partnerships with our customers by providing reliable products, consistent quality, and solutions that meet the evolving needs of the plastics industry.',
      ],
    },
    features: {
      title: 'Why Alhilal First',
      items: [
        {
          title: 'Lower Cost',
          desc: 'Economical solutions that help manufacturers reduce production costs without compromising quality.',
        },
        {
          title: 'Higher Quality',
          desc: 'Consistent, controlled specifications that guarantee reliable performance in every production batch.',
        },
        {
          title: 'More Flexibility',
          desc: 'A wide range of products covering PE, PP, and ready-to-use compound applications.',
        },
      ],
    },
    products: {
      title: 'Our Products',
      kicker: 'Calcium Carbonate & Ready-to-Use Compounds',
      intro: 'Al Hilal First Plastic Industries offers a diverse range of Calcium Carbonate products and custom compounds to meet the needs of various plastic industry applications, with multiple options in performance, thickness, whiteness, and cost to match different production requirements.',
      applicationsLabel: 'Applications',
      featuresLabel: 'Key Features',
      featuredBadge: 'Ready-to-Use Compound',
    },
    facility: {
      title: 'Our Facility',
      kicker: 'Misrata – Tawmina',
      desc: 'Our facility is located on the Coastal Road in Tawmina, Misrata, where production, packing, and storage take place under standards that ensure consistent quality in every batch.',
    },
    contact: {
      title: 'Contact Us',
      kicker: 'We Are Here to Serve You',
      desc: 'For inquiries, product requests, business cooperation, or further information about our products, please feel free to contact us through the following channels:',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      addressLabel: 'Company Location',
      closing: 'We are pleased to welcome you at our facility and discuss your industrial requirements and needs.',
      formTitle: 'Send Us a Message',
      formName: 'Full Name',
      formEmail: 'Email Address',
      formMessage: 'Your Message',
      formSubmit: 'Send via Email',
    },
    footer: {
      tagline: 'Calcium Carbonate for Plastic Industries — Made in Libya',
      rights: 'All rights reserved',
      quickLinks: 'Quick Links',
    },
  },
};
